import { EnvxSchema, EnvxType } from "./types";

export const allowedSchemaTypes: Array<EnvxType> = [
  "string",
  "number",
  "boolean",
  "enum",
  "email",
  "url",
];

// [COMING_SOON_FEATURES] future features
export const BUILTIN_SCHEMA: EnvxSchema = {
};
